import Cookie from './Cookie.class.js'
import { COOKIE } from '../../constants/GLOBAL_VARIABLE.js'

export default class InsignFrontCookie extends Cookie {
  constructor({ namespace }) {
    super()
    this.namespace = namespace || 'common'
  }

  getCookie(key) {
    const ifinsignFront = this.cookie?.get(COOKIE.INSIGN_FRONT) || null
    const insignFrontCookie = (ifinsignFront && JSON.parse(ifinsignFront)) || {}

    if (key) {
      return insignFrontCookie[this.namespace][key]
    }

    return insignFrontCookie[this.namespace] // ifinsign_front.iac
  }

  setCookie(data = {}) {
    if (!this.cookie) return

    const ifinsignFront = this.cookie?.get(COOKIE.INSIGN_FRONT) || null
    const insignFrontCookie = (ifinsignFront && JSON.parse(ifinsignFront)) || {}
    console.debug('[setCookie] insignFrontCookie', JSON.stringify(insignFrontCookie, null, 2))

    const ifinsign = this.cookie.get(COOKIE.INSIGN)
    const insignCookie = (ifinsign && JSON.parse(ifinsign)) || {}
    console.debug('[setCookie] insignCookie', JSON.stringify(insignFrontCookie, null, 2))

    insignFrontCookie[this.namespace] = {
      ...data,
      selector: insignCookie.selector || {},
    }
    console.debug(`[setCookie] insignCookie[${this.namespace}]`, JSON.stringify(insignFrontCookie[this.namespace], null, 2))

    const domain = window.location.host
    this.cookie.set(COOKIE.INSIGN_FRONT, JSON.stringify(insignFrontCookie), { domain })
  }

  clearCookie() {
    if (!this.cookie) return

    const ifinsignFront = this.cookie?.get(COOKIE.INSIGN_FRONT) || null
    const insignFrontCookie = (ifinsignFront && JSON.parse(ifinsignFront)) || {}

    delete insignFrontCookie[this.namespace] // 해당 namespace 제거

    const domain = window.location.host
    this.cookie.set(COOKIE.INSIGN_FRONT, JSON.stringify(insignFrontCookie), { domain })
  }
}
